import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig, queryClient } from '@/lib/react-query';




export const deleteAllNotification = async (): Promise<any | null> => {
  try {
    const response = await axios.delete(`/api/v1/user/clearNotification`);
    return response.data;
  } catch (error) {
    console.error('Failed to delete all notifications:', error);
    return null;
  }
};